
        <div *ngIf="!hasData" class="chart_no_data">
          No data
        </div>
        <div *ngIf="hasData" class="chart" #container></div>
        <div (pan)="onPan($event)"
        (panleft)="onPanLeft($event)"
        (panright)="onPanRight($event)">
        </div>
    